export default {
  methods: {
    mapLayerUtilitiesSewergaspointsAdd() {
      this.initPollUtilitiesSewergaspoints();
      this.map.addSource("utilities-sewergaspoints-source", {
        type: "geojson",
        data: this.computedUtilitiesSewergaspointsGeoJson
      });

      // Sewer point
      this.map.loadImage(
        "https://d1upyp0je0gcjj.cloudfront.net/utilities/sewergaspoints/sewer.png",
        (error, image) => {
          this.map.addImage("icon-utilities-sewergaspoints-sewer", image);
          this.map.addLayer({
            filter: ["==", "class", 1],
            id: "utilities-sewergaspoints-sewer",
            type: "symbol",
            source: "utilities-sewergaspoints-source",
            layout: {
              "icon-image": "icon-utilities-sewergaspoints-sewer",
              "icon-size": 0.25,
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer(
            "utilities-sewergaspoints-sewer",
            "marker-layer-points"
          );
        }
      );

      // Storm drain point
      this.map.loadImage(
        "https://d1upyp0je0gcjj.cloudfront.net/utilities/sewergaspoints/storm.png",
        (error, image) => {
          this.map.addImage("icon-utilities-sewergaspoints-storm", image);
          this.map.addLayer({
            filter: ["==", "class", 2],
            id: "utilities-sewergaspoints-storm",
            type: "symbol",
            source: "utilities-sewergaspoints-source",
            layout: {
              "icon-image": "icon-utilities-sewergaspoints-storm",
              "icon-size": 0.25,
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer(
            "utilities-sewergaspoints-storm",
            "marker-layer-points"
          );
        }
      );

      // Gas point
      this.map.loadImage(
        "https://d1upyp0je0gcjj.cloudfront.net/utilities/sewergaspoints/gas.png",
        (error, image) => {
          this.map.addImage("icon-utilities-sewergaspoints-gas", image);
          this.map.addLayer({
            filter: ["==", "class", 3],
            id: "utilities-sewergaspoints-gas",
            type: "symbol",
            source: "utilities-sewergaspoints-source",
            layout: {
              "icon-image": "icon-utilities-sewergaspoints-gas",
              "icon-size": 0.25,
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer(
            "utilities-sewergaspoints-gas",
            "marker-layer-points"
          );
        }
      );

      // SM Drain pit
      this.map.loadImage(
        "https://d1upyp0je0gcjj.cloudfront.net/utilities/sewergaspoints/smdrain.png",
        (error, image) => {
          this.map.addImage("icon-utilities-sewergaspoints-smdrain", image);
          this.map.addLayer({
            filter: ["==", "class", 4],
            id: "utilities-sewergaspoints-smdrain",
            type: "symbol",
            source: "utilities-sewergaspoints-source",
            layout: {
              "icon-image": "icon-utilities-sewergaspoints-smdrain",
              "icon-size": 0.25,
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer(
            "utilities-sewergaspoints-smdrain",
            "marker-layer-points"
          );
        }
      );

      // Unknown
      this.map.loadImage(
        "https://d1upyp0je0gcjj.cloudfront.net/utilities/sewergaspoints/unknown.png",
        (error, image) => {
          this.map.addImage("icon-utilities-sewergaspoints-unknown", image);
          this.map.addLayer({
            filter: [
              "all",
              ["!=", "class", 1],
              ["!=", "class", 2],
              ["!=", "class", 3],
              ["!=", "class", 4]
            ],
            id: "utilities-sewergaspoints-unknown",
            type: "symbol",
            source: "utilities-sewergaspoints-source",
            layout: {
              "icon-image": "icon-utilities-sewergaspoints-unknown",
              "icon-size": 0.09,
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer(
            "utilities-sewergaspoints-unknown",
            "marker-layer-points"
          );
        }
      );
    },
    mapLayerUtilitiesSewergaspointsRemove() {
      this.cancelPollUtilitiesSewergaspoints();
      this.map.removeImage("icon-utilities-sewergaspoints-sewer");
      this.map.removeImage("icon-utilities-sewergaspoints-gas");
      this.map.removeImage("icon-utilities-sewergaspoints-smdrain");
      this.map.removeImage("icon-utilities-sewergaspoints-storm");
      this.map.removeImage("icon-utilities-sewergaspoints-unknown");
      this.map.removeLayer("utilities-sewergaspoints-sewer");
      this.map.removeLayer("utilities-sewergaspoints-gas");
      this.map.removeLayer("utilities-sewergaspoints-smdrain");
      this.map.removeLayer("utilities-sewergaspoints-storm");
      this.map.removeLayer("utilities-sewergaspoints-unknown");
      this.map.removeSource("utilities-sewergaspoints-source");
    },
    initPollUtilitiesSewergaspoints() {
      this.$store.dispatch("actionGetGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/utilities/sewergaspoints",
        dept: "utilities",
        layer: "sewergaspoints",
        token: this.computedAuthToken
      });
      this.pollutilitiesSewergaspointsInterval = setInterval(() => {
        this.$store.dispatch("actionGetGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/utilities/sewergaspoints",
          dept: "utilities",
          layer: "sewergaspoints",
          token: this.computedAuthToken
        });
      }, this.computedInterval);
    },
    cancelPollUtilitiesSewergaspoints() {
      this.pollUtilitiesSewergaspointsInterval = clearInterval(
        this.pollUtilitiesSewergaspointsInterval
      );
    }
  },
  computed: {
    computedUtilitiesSewergaspointsGeoJson() {
      return this.$store.state.mapLayers.utilities.layers.sewergaspoints
        .geojson;
    },
    computedUtilitiesSewergaspointsMapVisibility() {
      return this.$store.state.mapLayers.utilities.layers.sewergaspoints
        .visibility.mapView;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    },
    computedInterval() {
      return this.$store.state.general.intervalLow;
    }
  },
  watch: {
    "$store.state.mapLayers.utilities.layers.sewergaspoints.geojson": {
      handler() {
        if (this.computedUtilitiesSewergaspointsGeoJson) {
          this.mapLayerUtilitiesSewergaspointsRemove();
          this.mapLayerUtilitiesSewergaspointsAdd();
        }
      }
    },
    "$store.state.mapLayers.utilities.layers.sewergaspoints.visibility.mapView": function(
      newValue
    ) {
      if (newValue) {
        this.mapLayerUtilitiesSewergaspointsAdd();
      } else {
        this.mapLayerUtilitiesSewergaspointsRemove();
      }
    }
  },
  beforeDestroy() {
    this.cancelPollUtilitiesSewergaspoints();
  }
};
